// @flow

import React, { useState } from "react";

import {
  getYear,
  format,
  endOfMonth,
  endOfYear,
  startOfMonth,
  startOfYear,
} from "date-fns";
import { it, enUS } from "date-fns/locale";
import type { SearchDateProps } from "../../../utils/_types";
import { object, func } from "prop-types";

type onSelectProps = {
  key: string,
  value: number | string | null,
};

const MySelect = (props) => {
  const { options, emptyOption = true, ...selectProps } = props;

  return (
    <select {...selectProps}>
      {emptyOption && (
        <option value="">{selectProps.placeholder ?? "-"}</option>
      )}
      {options.map((o) => (
        <option value={o.value} key={o.value}>
          {o.label}
        </option>
      ))}
    </select>
  );
};

const SearchDate = ({ onUpdateValue, translations }: SearchDateProps) => {
  const [data, setData] = useState({ year: getYear(new Date()), month: null });

  const currentYear = getYear(new Date());
  const { localize } = translations.language === "it" ? it : enUS;

  const startYear =
    document.getElementById("collection-search").dataset.startYear;
  const delta = startYear ? currentYear - parseInt(startYear) : 20;
  const years = Array.from(new Array(delta + 1), (val, index) => {
    return { value: currentYear - index, label: currentYear - index };
  });
  const months = Array.from(new Array(12), (val, index) => {
    return { value: index, label: localize.month(index) };
  });

  const onSelect = ({ key, value }: onSelectProps): void => {
    const newData = { ...data, [key]: value };

    if (key == "year" && !value) {
      setData(newData);
      onUpdateValue({
        start: "",
        end: "",
      });
      return;
    }
    const { year, month } = newData;
    let start = "";
    let end = "";

    if (year <= 0) {
      return;
    }
    if (month !== null && month !== undefined) {
      const monthDate = new Date(year, month);
      start = format(startOfMonth(monthDate), "yyyy-MM-dd HH:mm:ss");
      end = format(endOfMonth(monthDate), "yyyy-MM-dd HH:mm:ss");
    } else {
      const yearDate = new Date(year, 0);
      start = format(startOfYear(yearDate), "yyyy-MM-dd HH:mm:ss");
      end = format(endOfYear(yearDate), "yyyy-MM-dd HH:mm:ss");
    }

    setData(newData);
    onUpdateValue({
      start,
      end,
    });
  };
  return (
    <div className="dates-wrapper">
      <div className="field-wrapper">
        <MySelect
          id="year"
          name="year"
          placeholder={translations?.year_label ?? "Tutti gli anni"}
          onChange={(e) => {
            const v = e.target.value;
            onSelect({
              key: "year",
              value: v?.length > 0 ? parseInt(v) : null,
            });
          }}
          value={data.year}
          emptyOption={true}
          options={years}
          aria-label={translations?.year_label ?? "Tutti gli anni"}
        />
      </div>
      <div className="field-wrapper">
        <MySelect
          id="month"
          name="month"
          placeholder={translations?.month_label ?? "Tutti i mesi"}
          onChange={(e) => {
            const v = e.target.value;
            onSelect({
              key: "month",
              value: v?.length > 0 ? parseInt(v) : null,
            });
          }}
          value={data.month ?? ""}
          options={months}
          aria-label={translations?.month_label ?? "Tutti i mesi"}
        />
      </div>
    </div>
  );
};

SearchDate.propTypes = {
  onUpdateValue: func,
  translations: object,
};

export default SearchDate;
